export const generateRandomKey = () => {
    const randomNumber = () => {
        return Math.random() * 1000;
    };

    return randomNumber() + "-" + randomNumber();
};
